import { ChakraStylesConfig } from 'chakra-react-select';

export const roundedGreenClosable: ChakraStylesConfig = {
  container: (provided) => ({
    ...provided,
    borderRadius: 4,
    width: 'max-content',
  }),
  control: (provided) => ({
    ...provided,
    borderColor: 'blue.200',
    background: 'green.100',
    borderRadius: '50px',
    fontWeight: '600',
    _hover: {
      bg: 'green.100',
      cursor: 'pointer',
    },
    _focus: {
      boxShadow: 'outline',
      bg: 'green.100',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: 14,
    color: 'blue.200',
    position: 'unset',
    transform: 'unset',
    maxWidth: '100%',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: 14,
  }),
  option: (provided) => ({
    ...provided,
    minHeight: 35,
    color: 'black.700',
    fontSize: 14,
    bgColor: 'white',
    marginY: 2,
    _hover: {
      bg: 'green.100',
    },
    whiteSpace: 'nowrap',
  }),
  menu: (provided) => ({
    ...provided,
    'z-index': 10,
    marginTop: 2,
    borderRadius: '4px',
    boxShadow: '0 0 4px rgba(17, 39, 58, 0.15)',
    display: 'inline-table',
    overflow: 'visible',
    maxW: '1000px',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    borderRadius: 4,
    borderColor: 'grey.400',
    minW: 'fit-content',
    bgColor: 'white',
    '::-webkit-scrollbar': {
      width: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'grey.400',
      borderRadius: '2px',
    },
  }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    bgColor: 'transparent',
    color: 'blue.200',
    marginRight: 2,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    background: 'blue.200',
    _hover: {
      background: 'teal.700',
      _dark: {
        background: 'teal.700',
      },
    },
    color: 'white.100',
    fontSize: '8px',
    borderRadius: '20px',
    padding: '1px',
    marginRight: 2,
    h: '20px',
    w: '20px',
  }),
};
